import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import reduxThunk from 'redux-thunk';
import {SnackbarKey, SnackbarProvider} from 'notistack';
import {CssBaseline, IconButton, ThemeProvider} from '@material-ui/core';

import reducers from '@shared/store/reducers/Index';
import InitSharedRepo from '../../shared/index';

import './i18n';
import theme from './materialtheme';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {MAX_SNACKBARS} from './utils/SnackBarConfig';
import {Cancel} from '@material-ui/icons';

// import {Elements} from '@stripe/react-stripe-js';
// import {loadStripe} from '@stripe/stripe-js';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  {},
  composeEnhancers(applyMiddleware(reduxThunk))
);
InitSharedRepo.init();

const Index = (): React.ReactElement => {
  const notistackRef = React.createRef<any>();
  // const stripePromise = loadStripe(
  //   'pk_test_JJ1eMdKN0Hp4UFJ6kWXWO4ix00jtXzq5XG'
  // );

  const onClickDismiss = (key: SnackbarKey) => () => {
    if (notistackRef?.current?.closeSnackbar) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  return (
    <BrowserRouter>
      <Provider store={store}>
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <SnackbarProvider
              ref={notistackRef}
              preventDuplicate
              hideIconVariant
              maxSnack={MAX_SNACKBARS}
              action={key => {
                return (
                  <IconButton
                    style={{color: theme.palette.common.white}}
                    onClick={onClickDismiss(key)}>
                    <Cancel />
                  </IconButton>
                );
              }}
              style={{ fontSize: '14px' }}
              >
              {/* <Elements stripe={stripePromise}> */}
              {/* <MyCheckoutForm /> */}
              <App />
              {/* </Elements> */}
              {/* <App /> */}
            </SnackbarProvider>
          </ThemeProvider>
        </React.StrictMode>
      </Provider>
    </BrowserRouter>
  );
};
ReactDOM.render(<Index />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// registerServiceWorker()
